import clsx from "clsx"
import React, { FC } from "react"

import { classNames } from "../../utils/Helpers"
import { InputProps } from "../../utils/Interfaces"

export const FloatingInput: FC<InputProps> = ({
    css,
    name,
    value,
    error,
    label,
    posting,
    required,
    disabled,
    blurHandler,
    changeHandler,
    focusHandler,
}) => {
    const isDisabled = disabled ? disabled : posting

    return (
        <React.Fragment>
            <div className={clsx(css, "bg-white dark:bg-slate-800 w-full")}>
                <div className="relative bg-inherit">
                    <input type="text" name={name} id={name} placeholder={label} autoComplete="off"
                        className={classNames(
                            error.length > 0 ?
                                'text-red-900 dark:text-red-500 ring-slate-300 dark:ring-slate-600 focus:ring-red-600 border border-red-600 focus:outline-red-500' :
                                'text-slate-800 ring-slate-300 dark:ring-slate-600 focus:ring-orange-600 focus:outline-none focus:border-0 focus:ring-primary focus:outline-orange-500 border border-slate-300 hover:border-slate-400 dark:border-slate-400 dark:text-white',
                            'peer bg-transparent h-10 w-full rounded-md placeholder-transparent px-2 text-sm'
                        )} onChange={changeHandler} disabled={isDisabled} value={value} onBlur={blurHandler} onFocus={focusHandler} required={required} />
                    <label htmlFor={name}
                        className={clsx(
                            error.length > 0 ?
                                "text-red-600 dark:text-red-600 peer-placeholder-shown:text-red-500 peer-focus:text-red-600"
                                : "text-slate-500 dark:text-slate-400 hover:text-slate-600 peer-placeholder-shown:text-slate-500 dark:peer-placeholder-shown:text-slate-400 peer-focus:text-orange-600",
                            "absolute cursor-text left-0 -top-3 text-sm bg-inherit mx-2 px-1 peer-placeholder-shown:text-sm peer-placeholder-shown:top-2.5 peer-focus:-top-3 peer-focus:text-sm transition-all"
                        )}>
                        {label}
                    </label>

                    <div className="absolute inset-y-0 right-0 flex items-center w-8">
                        {
                            error.length > 0 ? (
                                <span className="fa-duotone text-red-500 fa-circle-exclamation fa-lg"></span>
                            ) : null
                        }
                    </div>
                </div>

                {
                    error.length > 0 ? (
                        <span className='invalid-feedback text-xs text-red-600 dark:text-red-400'>
                            {error}
                        </span>
                    ) : null
                }
            </div>
        </React.Fragment>
    )
}